import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import {
  listMedicalConceptsForOutlines,
  MedicalConceptListItem,
} from "#/services/articleOutlines";

export function useMedicalConceptsList(params?: { query?: string; limit?: number }) {
  return useQuery<MedicalConceptListItem[]>({
    queryKey: qk.medicalConceptsList(params),
    queryFn: () =>
      listMedicalConceptsForOutlines({
        query: params?.query,
        limit: params?.limit,
      }),
  });
}

export default useMedicalConceptsList;
